import RenderComponent from '@/modules/DynamicRenderPage';
import { useTheme } from '@material-ui/core/styles';
import { loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import React, { lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useManageScheduling } from './hooks/useManageSchedule';
import ParentStyled from './style';
import { handleDeleteScheduling, handleEditScheduling } from './utils/schedulingHandlers';

let Styled = loadStyle(ParentStyled, 'pages/web/ManageScheduling');
const config = loadPageConfig();
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.manageScheduling[1].name}`));

const ManageScheduling = (parentProps) => {
  const { fetchReportTypes, deleteScheduling, editScheduling, callback, fetchVehicles, getDrivers, drivers, vehicles, fetchSchedulingList } = parentProps;

  const { request, changeRequest, pagination, setPagination, fetchPaginateApi } = useManageScheduling({
    fetchSchedulingList,
    fetchVehicles,
    getDrivers,
    drivers,
    vehicles
  });

  const history = useHistory();
  const theme = useTheme();
  const i18n = useTranslation();
  const commonParentProps = { history, i18n, Styled, theme };

  const handleDelete = handleDeleteScheduling({ deleteScheduling, callback, request, fetchPaginateApi });
  const handleEdit = handleEditScheduling({ editScheduling, request, fetchPaginateApi });

  useEffect(() => {
    fetchReportTypes({ apiId: 'fetchReportTypes' });
  }, []);

  return (
    <>
      <RenderComponent
        {...config?.manageScheduling[0]}
        parentProps={{ ...parentProps }}
        commonParentProps={commonParentProps}
        component={Title}
      />
      <RenderComponent
        {...config?.manageScheduling[1]}
        parentProps={{
          ...parentProps,
          handleDelete,
          handleEdit,
          changeRequest,
          request,
          pagination,
          setPagination
        }}
        commonParentProps={commonParentProps}
        component={Content}
        pagination={pagination}
        setPagination={setPagination}
      />
    </>
  );
};

const mapState = (state) => ({
  apiStatus: state.asyncRequests,
  paginateList: state.downloadCenter.schedulingList,
  reportTypes: state.downloadCenter.reportTypes,
  drivers: state.drivers,
  vehicles: state.vehicles,
});

const mapDispatch = (dispatch) => ({
  fetchSchedulingList: (data) => dispatch.downloadCenter.fetchSchedulingList(data),
  fetchReportTypes: (data) => dispatch.downloadCenter.fetchReportTypes(data),
  deleteScheduling: (data) => dispatch.downloadCenter.deleteScheduling(data),
  editScheduling: (data) => dispatch.downloadCenter.editScheduling(data),
  fetchVehicles: (data) => dispatch.vehicles.fetchData(data),
  getDrivers: () => dispatch.drivers.getDrivers(),
});

export default connect(mapState, mapDispatch)(ManageScheduling);
